import { BlogIndexPage } from 'components/blog/blog-index-page';
import { BlogWrapper } from 'components/blog/blog-wrapper';
import { fetchTaggedArticles } from 'queries';

const EngineeringRoute = ({ ssr, router, session, store, toast }) => {
	// Render
	return <BlogIndexPage title='Engineering' ssr={ssr} />;
};

EngineeringRoute.getLayout = (page, ssr) => {
	const tag = ssr.tag?.data || {};
	return <BlogWrapper seo={{ description: tag.description }}>{page}</BlogWrapper>;
};

export async function getServerSideProps({ params, query }) {
	const articles = await fetchTaggedArticles('engineering', { params, query });
	return { props: { articles } };
}

export default EngineeringRoute;
